"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStoredTocNumbered = exports.getStoredTocIncludeTitle = exports.getStoredTocMaxLevel = exports.getTocNumbered = exports.getTocIncludeTitle = exports.getTocMaxLevel = exports.TOC_MAX_LEVELS = exports.DEF_NUMBERED = exports.DEF_INCLUDE_TITLE = exports.DEF_MAX_LEVEL = void 0;
exports.DEF_MAX_LEVEL = 3;
exports.DEF_INCLUDE_TITLE = true;
exports.DEF_NUMBERED = true;
exports.TOC_MAX_LEVELS = [1, 2, 3, 4, 5, 6];
const getTocMaxLevel = (value) => {
    if (typeof value !== 'number' || !Number.isFinite(value))
        return exports.DEF_MAX_LEVEL;
    const clamped = Math.min(6, Math.max(1, Math.round(value)));
    return clamped;
};
exports.getTocMaxLevel = getTocMaxLevel;
const getTocIncludeTitle = (value) => typeof value === 'boolean' ? value : exports.DEF_INCLUDE_TITLE;
exports.getTocIncludeTitle = getTocIncludeTitle;
const getTocNumbered = (value) => (typeof value === 'boolean' ? value : exports.DEF_NUMBERED);
exports.getTocNumbered = getTocNumbered;
const getStoredTocMaxLevel = (value) => value === exports.DEF_MAX_LEVEL ? undefined : value;
exports.getStoredTocMaxLevel = getStoredTocMaxLevel;
const getStoredTocIncludeTitle = (value) => value === exports.DEF_INCLUDE_TITLE ? undefined : value;
exports.getStoredTocIncludeTitle = getStoredTocIncludeTitle;
const getStoredTocNumbered = (value) => value === exports.DEF_NUMBERED ? undefined : value;
exports.getStoredTocNumbered = getStoredTocNumbered;
